import FAQCollection from 'components/Content/FAQCollection/FAQCollection.f';

export default FAQCollection;
